import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import Time from "./Time";
import Waypoint from "react-waypoint";
import shortid from "shortid";
import "./styles/ChatWindow.css";

class ChatWindow extends Component {
  constructor() {
    super();
    this._HANDSHAKE = "handshake";
    this._CHAT = "chat";
    this._RECEIPT = "receipt";
    this._loadedConversationIndex = 1;
  }

  _handleLoadMoreConversations = () => {
    this._loadedConversationIndex++;
    this.props.loadConversations(this._loadedConversationIndex);
  };

  _showModal = url => {
    this.props.showModal(url);
  };

  _renderReceipt = message => {
    return (
      <div>
        <div className="ChatWindow--reciept">
          <p className="ChatWindow--reciept---title">
            {message.title.toUpperCase()}
          </p>
          <img src={message.image} alt="transaction reciept" />
        </div>
        <span>{message.text}</span>
      </div>
    );
  };

  _renderButtons = message => {
    return (
      <div>
        <div className="ChatWindow--buttons">
          {message.buttons.map((button, index) => {
            let url = message.buttons[index].link;
            let title = message.buttons[index].title;
            return (
              <div key={shortid.generate()}>
                <div className="ChatWindow--buttons">
                  <a
                    className="ChatWindow--buttons--option"
                    onClick={this._showModal.bind(this, url)}
                    target="_blank"
                  >
                    {title}
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  replaceNewline = text => {
    return { __html: text.replace(/(?:\r\n|\r|\n)/g, "<br/>") };
  };

  _renderChat = message => {
    return (
      <div>
        {message.text.indexOf("\n") === -1 ? (
          <span>{message.text}</span>
        ) : (
          <span dangerouslySetInnerHTML={this.replaceNewline(message.text)} />
        )}
        {message.buttons && this._renderButtons(message)}
      </div>
    );
  };

  _renderWaypoint = () => {
    return (
      this.props.shouldLoadMoreConversations && (
        <li className="ChatWindow--list---in">
          <Waypoint onEnter={this._handleLoadMoreConversations} />
          Loading more conversations...
        </li>
      )
    );
  };

  render() {
    return (
      <div className="ChatWindow__container">
        <ul className="ChatWindow" ref={this.props.chatWindowRef}>
          <ReactCSSTransitionGroup
            transitionName="chatanimation"
            transitionEnterTimeout={200}
            transitionLeaveTimeout={100}
          >
            {this._renderWaypoint()}
            {this.props.userConversations.map(message => {
              return message["id"].indexOf("KUDI") === 0 ? (
                <li
                  key={message.id}
                  id={`#${message.id}`}
                  className="ChatWindow--list---in"
                >
                  <div className="ChatWindow--text---in">
                    {message.type === this._CHAT && this._renderChat(message)}
                    {message.type === this._RECEIPT &&
                      this._renderReceipt(message)}
                  </div>
                  <div className="ChatWindow--time">
                    <Time d={message.d} />
                  </div>
                </li>
              ) : (
                <li
                  key={message.id}
                  id={`#${message.id}`}
                  className="ChatWindow--list---out"
                >
                  <div className="ChatWindow--text---out">{message.text}</div>
                  <div className="ChatWindow--time">
                    <Time d={message.d} />
                  </div>
                </li>
              );
            })}
          </ReactCSSTransitionGroup>
        </ul>
      </div>
    );
  }
}

ChatWindow.propTypes = {
  userConversations: PropTypes.array.isRequired,
  chatWindowRef: PropTypes.func.isRequired
};

export default ChatWindow;



// WEBPACK FOOTER //
// ./src/modules/ChatWindow.js